import { FormControl, FormHelperText } from '@mui/material'
import React, { useContext } from 'react'
import { FieldContext } from '../constants'
import { FieldControllerContext } from '../stores/context'

export const FieldHelperText: React.FC = () => {
  const { name, helperText } = useContext(FieldContext)
  const { errors } = useContext(FieldControllerContext)

  const fieldHelperText = (errors && errors[name as string]?.message) || helperText
  const isError = !!fieldHelperText || !!helperText

  return (
    <FormControl error={isError}>
      <FormHelperText sx={{ m: 0 }}>{fieldHelperText}</FormHelperText>
    </FormControl>
  )
}
